<p-confirmDialog rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
<app-top-bar [topBarTitle]="topBarTitle"></app-top-bar>
<div class="bpt-main-content-container" *ngIf="accessToAGs; else NoAccessToAssignmentGroup">
  <div class="flex card-container">
    <div class="label-wrapper">
      <label>{{ treeSelectPlaceHolderText }}</label>
    </div>
    <div class="flex flex-row scope-wrapper">
      <div class="tree-wrapper">
        <p-treeSelect
          selectionMode="single"
          [(ngModel)]="selectedScope"
          [options]="treeData"
          [filter]="true"
          [showClear]="true"
        ></p-treeSelect>
      </div>
      <div class="button-wrapper">
        <p-button
        appPreventDoubleClick
          label="{{ addAssignmentTitle }}"
          id="addAssignmentButton"
          class="add-Assignment-button"
          icon="fa fa-plus"
          iconPos="left"
          (debounceClick)="addAssignmentGroup()"
        ></p-button>
      </div>
    </div>
    <app-assignment-group-panel-list 
    [scopeId]="selectedScope"
    (assignmentGroupToEdit)="editAssignmentGroupSlider($event)"
    >
    </app-assignment-group-panel-list>
    <app-create-assignment-group-slider
      [isAssignmentGroupSliderOpen]="isAssignmentGroupSliderOpen"
      [assignmentGroupToEdit]="assignmentGroupToEdit"
      (isAssignmentGroupSliderActive)="closeAssignmentGroupSlider($event)"
    ></app-create-assignment-group-slider>
  </div>
</div>

<ng-template #NoAccessToAssignmentGroup>
  <app-error [errorMessage]="NoAccessToAssignmentGroupErrorMessage()"></app-error>
</ng-template>
